import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import { getApiBaseUrl } from "./api/client";
import { migrateLegacyStorageKeys } from "./shared/storage";

migrateLegacyStorageKeys();

if (import.meta.env.DEV) {
  console.info("[Grey Dates] API base URL:", getApiBaseUrl());
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
